import React, {Component} from 'react';
import styles from "./detailBonusStates.module.scss";

export default class HiddenBonus extends Component {
  render() {
    return (
      <div className={styles.Hidden}>
        <span>Промокод скрыт</span>
      </div>
    )
  }
}
